'use client';

import { v4 } from 'uuid';
import { DataTableWrapper } from '@/components/Shared/DataTableWrapper';
import { LoadingAlert } from '@/components/Shared/LoadingAlert';
import { DataTable } from '@/components/ui/data-table';
import { Skeleton } from '@/components/ui/skeleton';
import { columns } from './summaryColumns';
const skeletonColumns = columns.map(col => ({
  ...col,
  cell: () => <Skeleton key={v4()} className="bg-secondary-readable/[0.25] h-4 w-full" />
}));
export function TableSummarySkeleton({
  length
}: {
  length: number;
}) {
  return <div className="p-5 bg-white">
      <LoadingAlert title="Fetching summary" />

      <div className="mt-5">
        <DataTableWrapper>
          <DataTable columns={skeletonColumns} data={new Array(length).fill({})} />
        </DataTableWrapper>
      </div>
    </div>;
}